export const profileActions = {
  fetchHelptexts: () => ({
    type: "helptexts.fetch"
  }),
  fetchHelptextsSuccess: payload => ({
    type: "helptexts.success",
    payload
  }),
  fetch: () => ({
    type: "profile.fetch"
  }),
  fetchSuccess: payload => ({
    type: "profile.success",
    payload
  }),
  fetchFailure: payload => ({
    type: "profile.failure",
    payload
  }),
  setIsFetchingPunchoutUrl: (payload) => ({
    type: "profile.setIsFetchingPunchoutUrl",
    payload,
  }),
  fetchHasCattle: () => ({
    type: "profile.hasCattlefetch"
  }),
  fetchHasCattleSuccess: payload => ({
    type: "profile.hasCattlesuccess",
    payload
  }),
  fetchHasCattleFailure: payload => ({
    type: "profile.hasCattlefailure",
    payload
  }),
  fetchIsSuperuser: () => ({
    type: "profile.isSuperuserFetch"
  }),
  fetchIsSuperuserSuccess: payload => ({
    type: "profile.isSuperuserFetch.success",
    payload
  }),
  fetchIsSuperuserFailure: payload => ({
    type: "profile.isSuperuserFetch.failure",
    payload
  }),
  save: payload => ({
    type: "profile.save",
    payload
  }),
  saveSuccess: payload => ({
    type: "profile.save.success",
    payload
  }),
  saveFailure: payload => ({
    type: "profile.save.failure",
    payload
  }),
  fetchPrognosisRegistrationConfig: payload => ({
    type: "prognosis_registration_config.fetch",
    payload
  }),
  fetchPrognosisRegistrationConfigSuccess: payload => ({
    type: "prognosis_registration_config.fetch.success",
    payload
  }),
  fetchPrognosisRegistrationConfigFailure: payload => ({
    type: "prognosis_registration_config.fetch.failure",
    payload
  }),
  fetchPrognosisSubmitted: payload => ({
    type: "prognosis_submitted.fetch",
    payload
  }),
  fetchPrognosisSubmittedSuccess: payload => ({
    type: "prognosis_submitted.fetch.success",
    payload
  }),
  fetchPrognosisSubmittedFailure: payload => ({
    type: "prognosis_submitted.fetch.failure",
    payload
  }),

  fetchPrognosisStatistics: payload => ({
    type: "prognosis_statistics.fetch",
    payload
  }),
  fetchPrognosisStatisticsSuccess: payload => ({
    type: "prognosis_statistics.fetch.success",
    payload
  }),
  fetchPrognosisStatisticsFailure: payload => ({
    type: "prognosis_statistics.fetch.failure",
    payload
  }),

  registerPrognosis: payload => ({
    type: "prognosis.register",
    payload
  }),
  registerPrognosisSuccess: payload => ({
    type: "prognosis.register.success",
    payload
  }),
  registerPrognosisFailure: payload => ({
    type: "prognosis.register.failure",
    payload
  }),

  openPrognosisRegistration: () => ({
    type: "prognosis_registration.open"
  }),
  closePrognosisRegistration: () => ({
    type: "prognosis_registration.close"
  })
};
